module.exports = __webpack_public_path__ + "r-v3/img/ico_check_color.843393b6.svg";